import React from "react";
import Category from "./shopBy/Category";
import Price from "./shopBy/Price";

const ShopSideNav = ({
  data,
  onCategoryFilter,
  onBrandFilter,
  onPriceFilter
}) => {
  return (
    <div className="w-full flex flex-col gap-6">
      <Category
        data={data}
        onCategoryFilter={onCategoryFilter}
      />

      <Price
        onPriceFilter={onPriceFilter}
      />
    </div>
  );
};

export default ShopSideNav;